import { Link } from "react-router-dom";
import { Page } from "../components/Layout.tsx";

export default function NotFound() {
  return (
    <Page testid="screen-notfound">
      <div className="card text-center">
        <h1 className="text-2xl font-semibold text-ink-900">Dead link</h1>
        <p className="mt-2 text-ink-400">
          This invite or page doesn't exist. It may have expired or the account was deleted.
        </p>
        <Link to="/" className="btn-primary mt-4">
          Start fresh
        </Link>
      </div>
    </Page>
  );
}
